import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { AuthGuard } from './utils/guards/auth.guard';
import { AdminUsersComponent } from './views/admin-users/admin-users.component';
import { UsersComponent } from './views/users/users.component';
import { applicationsLoadedResolver } from './utils/resolvers/applications-loaded.resolver';
import { languagesLoadedResolver } from './utils/resolvers/languages-loaded.resolver';
import { UserDetailsComponent } from './views/users/user-details/user-details.component';
import { LanguagesComponent } from './views/languages/languages.component';
import { LanguageTranslationsComponent } from './views/languages/language-translations/language-translations.component';
import { VersionsComponent } from './views/versions/versions.component';
import { NewsComponent } from './views/news/news.component';
import { ShopComponent } from './views/shop/shop.component';
import { SlotsComponent } from './views/slots/slots.component';
import { TournamentsComponent } from './views/tournaments/tournaments.component';
import { LevelsComponent } from './views/levels/levels.component';
import { MatchsComponent } from './views/matchs/matchs.component';
import { MissionsComponent } from './views/missions/missions.component';
import { LeaguesComponent } from './views/leagues/leagues.component';
import { ApplicationsComponent } from './views/applications/applications.component';
import { GlobalConfigurationsComponent } from './views/configurations/global/global-configurations.component';
import { GameServerConfigurationsComponent } from './views/configurations/game-server/game-server-configurations.component';
import { GameClientConfigurationsComponent } from './views/configurations/game-client/game-client-configurations.component';
import { BugReportsComponent } from './views/bug-reports/bug-reports.component';
import { CollectionsComponent } from './views/collections/collections.component';
import { CollectionAlbumsComponent } from './views/collections/collection-albums/collection-albums.component';
import { CollectionCardsComponent } from './views/collections/collection-cards/collection-cards.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuard],
    resolve: { applicationsLoaded: applicationsLoadedResolver, languagesLoaded: languagesLoadedResolver },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then(m => m.routes)
      },
      // admin
      {
        path: 'backoffice',
        children: [
          {
            path: 'management',
            canActivate: [AuthGuard],
            data: {
              title: 'Management',
            },
            children: [
              {
                path: '',
                redirectTo: 'users',
                pathMatch: 'full'
              },
              {
                path: 'users',
                component: UsersComponent,
                canActivate: [AuthGuard],
                data: {
                  title: 'Users',
                }
              },
              {
                path: 'user-details',
                component: UserDetailsComponent,
                canActivate: [AuthGuard],
                data: {
                  title: 'User details',
                }
              },
              {
                path: 'news',
                component: NewsComponent,
                canActivate: [AuthGuard],
                data: { title: 'News' }
              },
              {
                path: 'bug-reports',
                component: BugReportsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Bug Reports' }
              },
            ]
          },
          {
            path: 'configuration',
            canActivate: [AuthGuard],
            data: { title: 'Configuration' },
            children: [
              {
                path: '',
                redirectTo: 'languages',
                pathMatch: 'full'
              },
              {
                path: 'languages',
                component: LanguagesComponent,
                canActivate: [AuthGuard],
                data: { title: 'Languages' }
              },
              {
                path: 'language-translations',
                component: LanguageTranslationsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Language Translations' }
              },
              {
                path: 'versions',
                component: VersionsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Versions' }
              },
              {
                path: 'shop',
                component: ShopComponent,
                canActivate: [AuthGuard],
                data: { title: 'Shop' }
              },
              {
                path: 'slots',
                component: SlotsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Slots' }
              },
              {
                path: 'tournaments',
                component: TournamentsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Tournaments' }
              },
              {
                path: 'levels',
                component: LevelsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Levels' }
              },
              {
                path: 'matchs',
                component: MatchsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Matchs' }
              },
              {
                path: 'missions',
                component: MissionsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Missions' }
              },
              {
                path: 'leagues',
                component: LeaguesComponent,
                canActivate: [AuthGuard],
                data: { title: 'Leagues' }
              },
              {
                path: 'collections',
                component: CollectionsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Collections' }
              },
              {
                path: 'collection-albums',
                component: CollectionAlbumsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Collection Albums' }
              },
              {
                path: 'collection-cards',
                component: CollectionCardsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Collection Cards' }
              },
              {
                path: 'applications',
                component: ApplicationsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Applications' }
              },
              {
                path: 'global',
                component: GlobalConfigurationsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Global' }
              },
              {
                path: 'server-configurations',
                component: GameServerConfigurationsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Server Configurations' }
              },
              {
                path: 'client-configurations',
                component: GameClientConfigurationsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Client Configurations' }
              },
            ]
          },
          {
            path: 'administration',
            canActivate: [AuthGuard],
            data: {
              title: 'Administration',
            },
            children: [
              {
                path: '',
                redirectTo: 'admin-users',
                pathMatch: 'full'
              },
              {
                path: 'admin-users',
                component: AdminUsersComponent,
                canActivate: [AuthGuard],
                data: {
                  title: 'Utilisateurs',
                }
              },
            ]
          },
        ]
      },
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];
